import { ReactElement } from 'react'

import { Switch } from 'antd'

import { ConditionalWrapper } from 'components/ConditionalWrapper'
import { ToolTip } from 'components/ToolTip'

import { FormikWithCustomHandlersProps } from '../propTypes'
import withCustomHandlers from '../withCustomHandlers'

type FormikSwitchProps<V> = FormikWithCustomHandlersProps<V> & {
    handlePostChange: (value: any) => void
    tooltipPlacement?: 'top' | 'bottom' | 'left' | 'right'
    tooltipTitle?: string
}

function FormikSwitch<V extends boolean>({
    field: { value },
    form,
    handleChange,
    handlePostChange,
    handleBlur,
    handleClick,
    tooltipPlacement = 'bottom',
    tooltipTitle,
    ...props
}: FormikSwitchProps<V>): ReactElement {
    return (
        <ConditionalWrapper
            condition={Boolean(tooltipTitle)}
            wrapper={(children) => (
                <ToolTip
                    title={tooltipTitle}
                    arrow={{ pointAtCenter: true }}
                    placement={tooltipPlacement}
                >
                    <span
                        style={{
                            display: 'inline',
                            width: 'fit-content',
                        }}
                    >
                        {children}
                    </span>
                </ToolTip>
            )}
        >
            <Switch checked={value} onChange={handleChange} {...props} />
        </ConditionalWrapper>
    )
}

export default withCustomHandlers(FormikSwitch)
